import { Link, useLocation } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="relative flex min-h-screen flex-col items-center justify-center overflow-hidden bg-background-950 px-4 text-center">
      <span className="pointer-events-none absolute select-none font-heading text-[8rem] font-black leading-none text-background-800 md:text-[14rem]">
        404
      </span>
      <div className="relative z-10">
        <span className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-accent-500/15 text-accent-400">
          <i className="ri-emotion-sad-line text-3xl" />
        </span>
        <h1 className="mt-6 font-heading text-2xl font-bold text-foreground-50 md:text-3xl">
          抱歉，你访问的页面走丢了
        </h1>
        <p className="mt-2 text-sm text-secondary-400">{location.pathname}</p>
        <p className="mt-4 max-w-md text-sm text-foreground-400">
          页面可能已被移除或链接有误，返回首页继续探索精彩影视内容吧。
        </p>
        <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
          <Link
            to="/"
            className="flex items-center gap-2 whitespace-nowrap rounded-md bg-accent-500 px-6 py-3 text-sm font-semibold text-background-950 transition-colors hover:bg-accent-600 cursor-pointer"
          >
            <i className="ri-home-5-line text-lg" />
            返回首页
          </Link>
          <Link
            to="/search"
            className="flex items-center gap-2 whitespace-nowrap rounded-md border border-background-700 px-6 py-3 text-sm font-semibold text-foreground-100 transition-colors hover:border-accent-400 hover:text-accent-400 cursor-pointer"
          >
            <i className="ri-search-line text-lg" />
            去搜索
          </Link>
        </div>
      </div>
    </div>
  );
}